// extracted by mini-css-extract-plugin
export var animating = "_24-3";
export var background = "_24-6";
export var constrainHeight = "_24-2";
export var dark = "_24-4";
export var dropdown = "_24-1";
export var leave = "_24-5";
export var option = "_24-7";
export var root = "_24-0";